import {Injectable} from '@angular/core';
import {HttpProvider} from "../http/http";
import {observable} from "rxjs/symbol/observable";
import {Observable} from "rxjs/Observable";
import {global} from "../../environments/global";

/*
  Generated class for the SupportProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class SupportProvider {

  tags: Array<any>;

  supports: Array<any>;

  constructor(public http: HttpProvider) {
    console.log('Hello SupportProvider Provider');
  }

  /**
   * 获取业务员成绩列表*/
  getSupportRanking(){

    return this.http.hPost('/employee/ranking');
  }

  /**
   * 多个地方调用，复用一下*/
  getSupportRankingMerge(client,page,pagesize){
    return this.http.hPost('/employee/ranking',{sub_client_id:client,page:page,pagesize:pagesize})
  }

  /**
   * 获取业务员详细信息*/
  getSupportDetail(username){
    return this.http.hPost('/employee/detail', {username: username});
  }

  /**
   * 获取某个业务员的每一条被@的消息*/
  getRecords(page: number, pagesize: number, username: string){
    return this.http.hPost('/employee/record', {
      page: page,
      pagesize: pagesize,
      username: username
    });
  }

  /**
   * 获取所有可用的标签*/
  getAllTags(){
    return this.http.hPost('/employee/get_tag_list');
  }

  /**
   * 多个地方调用，复用一下*/
  getAllTagsMerge(){
    if(this.tags){
      return Observable.of(this.tags);
    } else {
      return this.getAllTags().map(res =>{
        return res.content.tag_list;
      });
    }
  }

  /**
   * 增删tag*/
  editSupportTags(username, ids){
    return this.http.hPost('/employee/tag_edit', {username: username, tag_list: ids});
  }

  /**
   * 搜索某个业务员*/
  searchSupport(keyword:string){
    return this.http.hPost('/employee/search', {keyword: keyword});
  }

  /**
   * 获取格式错误的msg*/
  getSupportWrongMsg(page: number, pagesize: number,client:string, username?: string){
    let params = {
      page: page,
      pagesize: pagesize,
      username: username
    };
    let url = '/employee/wrong_log';
    if(global.shangCengFlag){
      // url = '/employee_wrong_log_shangceng';
      params['sub_client_id'] = client;
    }

    return this.http.hPost(url, params);
  }

  getSubList(){
    return this.http.hPost('/employee/get_sub_list');
  }
}



// WEBPACK FOOTER //
// ./src/providers/support/support.ts